import React from "react";
import { useNavigate } from "react-router-dom";
import "./DashboardPage.css";
import ActiveUserLineChart from "../../components/common/activeUserLineChart";
import Cards from "../../components/common/cards";
import UsersPieChart from "../../components/common/UsersPieChart";
import RecentActivity from "../../components/common/recentActivity";
import AnalyticsReport from "../../components/common/AnalyticsReport";

export default function DashboardPage() {
  //   const navigate = useNavigate();
  //   const handleLogout = () => {
  //     localStorage.removeItem('token');
  //     localStorage.removeItem('user');
  //     navigate('/login');
  //   };

  return (
    <>
      <Cards />
      <div className="dashboard-content">
        {/* <div className="welcome-card">
          <h2>Welcome to Indeva Admin Panel!</h2>
          <p>You have successfully logged in.</p>
        </div> */}
        <ActiveUserLineChart />
        <UsersPieChart />
      </div>

      <AnalyticsReport />

      <RecentActivity />
    </>
  );
}